/**
 * Generate the cart URL based on the current locale
 * @param locale - The current locale (e.g., 'en', 'nl')
 * @returns The properly formatted cart URL
 */
export function getCartUrl(locale: string): string {
    // Dutch is the default locale (no prefix)
    // All other locales get a prefix
    return locale === 'nl' ? '/cart' : `/${locale}/cart`;
}
